import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Row, Col, Dropdown, DropdownButton } from 'react-bootstrap';
import { getCountryName, isVatEnabled, is3DSEnabled } from '../../../util/countries';

import '../Addon.scss';

class BillingInfoForm extends Component {
  static defaultProps = {
    model: {},
    onChange: function () {},
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    let target = e.target;
    const model = { ...this.props.model, [target.name]: target.value };

    if (target.name == 'country' && !isVatEnabled(target.value)) {
      model.vat = undefined;
    }
    if (target.name == 'country' && is3DSEnabled(target.value)) {
      model.threeDS = true;
    }

    this.props.onChange(model);
  }

  render() {
    const { countries, model } = this.props;

    return (
      <Form className='form_billing'>
        <Row>
          <Col sm={6}>
            <Form.Group controlId="firstName">
              <Form.Label>First name</Form.Label>
              <Form.Control type="text" name="firstName" value={model.firstName} onChange={this.handleChange} />
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group controlId="lastName">
              <Form.Label>Last name</Form.Label>
              <Form.Control type="text" name="lastName" value={model.lastName} onChange={this.handleChange} />
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group controlId="country">
              <Form.Label>Country</Form.Label>
              <DropdownButton
                id="countries"
                className='form-control-dropdown'
                title={getCountryName(model.country) || 'Select country'}
              >
                {countries &&
                  countries.map((c, i) => (
                    <Dropdown.Item
                      key={i}
                      onClick={() =>
                        this.handleChange({
                          target: { name: 'country', value: c.code },
                        })
                      }
                    >
                      {c.name}
                    </Dropdown.Item>
                  ))}
              </DropdownButton>
            </Form.Group>
          </Col>
          <Col sm={6}>
            {isVatEnabled(model.country) && (
              <Form.Group controlId="vat">
                <Form.Label>VAT</Form.Label>
                <Form.Control type="text" name="vat" value={model.vat} onChange={this.handleChange} />
              </Form.Group>
            )}
          </Col>
          <Col sm={6}>
            <Form.Group controlId="company">
              <Form.Label>Company </Form.Label>
              <Form.Control type="text" name="company" value={model.company} onChange={this.handleChange} />
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group controlId="city">
              <Form.Label>City</Form.Label>
              <Form.Control type="text" name="city" value={model.city} onChange={this.handleChange} />
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group controlId="state">
              <Form.Label>State / region</Form.Label>
              <Form.Control type="text" name="state" value={model.state} onChange={this.handleChange} />
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group controlId="zip">
              <Form.Label>ZIP code</Form.Label>
              <Form.Control type="text" name="zip" value={model.zip} onChange={this.handleChange} />
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group controlId="address">
              <Form.Label>Address</Form.Label>
              <Form.Control type="text" name="address" value={model.address} onChange={this.handleChange} />
            </Form.Group>
          </Col>
          <Col sm={12}>
            <Form.Group controlId="billingEmails">
              <Form.Label>Billing emails</Form.Label>
              <Form.Control type="email" name="billingEmails" value={model.billingEmails} onChange={this.handleChange} />
              <small className="text-muted">Additional email addresses must be separated by a comma</small>
            </Form.Group>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    countries: state.subscription.countries,
  };
};

export default connect(mapStateToProps)(BillingInfoForm);
